"use client";
import Link from "next/link";
import BookImage from "@/components/BookImage";
import { bookPageUrl } from "@/utils/routes";
import { Book } from "@/types/Book";

interface BookComponentProps {
  book: Book;
  referer: string;
  enableHistory?: boolean;
}

function updateRecentBooks(book: Book) {
  const storageKey = "recentBooks";
  const maxItems = 54;

  const recentBooks = JSON.parse(localStorage.getItem(storageKey) || "[]");

  const existingIndex = recentBooks.findIndex((item: Book) => item.id === book.id);
  if (existingIndex !== -1) {
    recentBooks.splice(existingIndex, 1);
  }

  recentBooks.unshift(book);

  if (recentBooks.length > maxItems) {
    recentBooks.splice(maxItems);
  }

  localStorage.setItem(storageKey, JSON.stringify(recentBooks));
}

export function BookComponent({ book, referer, enableHistory }: BookComponentProps) {
  const handleClick = () => {
    if (enableHistory) {
      updateRecentBooks(book);
    }
  };

  return (
    <div className="max-md:w-full max-md:max-w-[400px] md:w-[160px]">
      <Link href={bookPageUrl(book.slug, referer)} onClick={handleClick}>
        <BookImage
          width={160}
          height={233}
          className="h-auto max-md:w-full max-w-[400px] md:h-[233px] md:w-[160px] object-cover m-auto md:hover:scale-105 transition-transform"
          book={book}
        />
      </Link>

      <div className="flex justify-between">
        <div>
          <Link
            href={bookPageUrl(book.slug, referer)}
            className="hover:underline"
            onClick={handleClick}>
            <h3 className="text-sm font-semibold mt-2">{book.title}</h3>
          </Link>
          <p className="text-xs text-muted-foreground">{book.author}</p>
        </div>
      </div>
    </div>
  );
}
